import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=367bc3da&scoped=true&"
import script from "./Productos.vue?vue&type=script&lang=js&"
export * from "./Productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bc3da",
  null
  
)

export default component.exports